<div class="oauth-login-form" *ngIf="!passwordExpirySettings?.passwordExpiry && !passwordExpirySettings?.controlPasswordExpired">
  <div class="row-login row">
    <div class="col-xs-12 col-sm-8 col-md-6 login-left">
      <div style="padding: 15px">
        <!--logo section -->
        <div class="row">
          <div class="container-fluid">
            <div class="login-header text-center">
              <img
                [src]="this.logoPath"
                class="logo"
                alt="able+"
                title="able+"
              />
              <h3 class="title hidden">able+</h3>
            </div>
          </div>
        </div>
        <!--logo section end-->
        <form
          name="form"
          (keydown.enter)="handleLoginEvents(f.form.valid)"
          #f="ngForm"
        >
          <div class="row"  >
            <div
              class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11"
            >
              <span class="input-group-addon">
                <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M5,3V21H11V17.5H13V21H19V3H5M7,5H9V7H7V5M11,5H13V7H11V5M15,5H17V7H15V5M7,9H9V11H7V9M11,9H13V11H11V9M15,9H17V11H15V9M7,13H9V15H7V13M11,13H13V15H11V13M15,13H17V15H15V13M7,17H9V19H7V17M15,17H17V19H15V17Z"
                  />
                </svg>
              </span>
              <div
                *ngIf="!selectedOrganisationName"
                class="form-group label-floating is-empty"
                [ngClass]="{ 'has-error': f.submitted && !f.valid, 'is-empty': false }"
              >
                <label class="control-label" [ngClass]="{ 'dirty-input-label ': null != null}">Organisation</label>
                <ng-container >
                  <input
                    type="text"
                    list="organisations"
                    id="organisation"
                    class="form-control"
                    name="organisation"
                    (keyup)="searchOrganisationsForLogin($event.target?.value)"
                    #organisation
                    [(ngModel)]="loginModel.organisation"
                    required
                  />
                  <datalist
                    *ngIf="organisationsList?.length > 0"
                    id="organisations"
                  >
                    <option *ngFor="let org of organisationsList">
                      {{ org.organisationName }}
                    </option>
                  </datalist>
                </ng-container>
              </div>
              <div *ngIf="selectedOrganisationName" class="form-group label-floating is-empty">
                <span
                  style="
                    color: #3c4043;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.25px;
                    font-family: Arial, Helvetica, sans-serif;
                  "
                >
                  <b>{{selectedOrganisationName}}</b>
                </span>
                <a *ngIf="removableOrganization"
                   style="cursor: pointer; color: #3c4043"
                   class="pull-right"
                   title="Remove organisation"
                   (click)="onRemove(true)"
                >
                  <i class="material-icons">clear</i>
                </a>
              </div>
            </div>

          </div>
          <ng-container *ngIf="userNameValidated">
            <ng-container *ngTemplateOutlet="validatedUsername; context: {$implicit: userNameValidated, avatar: avatar, removeFn: onRemove}"></ng-container>
            <div class="row" >
              <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
              <span class="input-group-addon">
                <i class="material-icons">lock</i>
              </span>
                <div
                  class="form-group label-floating"
                  [ngClass]="{ 'has-error': f?.submitted && !password.valid, 'is-empty': password == '' }"
                >
                  <label class="control-label">Password</label>
                  <input
                    [type]="passwordInputType"
                    class="form-control"
                    name="password"
                    [(ngModel)]="loginModel.password"
                    #password="ngModel"
                    required
                  />
                  <span
                    *ngIf="passwordMode"
                    title="Show password"
                    class="input-group-addon addon-right text-gray cursor-pointer"
                    (click)="changePasswordMode(false)"
                  >
                  <i class="mdi mdi-eye"></i>
                </span>
                  <span
                    *ngIf="!passwordMode"
                    title="Hide password"
                    class="input-group-addon addon-right text-gray cursor-pointer"
                    (click)="changePasswordMode(true)"
                  >
                  <i class="mdi mdi-eye-off"></i>
                </span>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!userNameValidated">
            <ng-container *ngTemplateOutlet="inputUserName; context: {$implicit: loginModel, form: f}"></ng-container>
          </ng-container>
          <div
            class="text-center margin-top-base padding-top-base" >
            <button
              type="button"
              (click)="f.form.valid && handleLoginEvents(f.form.valid)"
              (keydown.enter)="f.form.valid && handleLoginEvents(f.form.valid)"
              [disabled]="loading && !f.form.valid"
              class="btn btn-primary btn-block"
              [ngStyle]="{ 'background-color': this.sharedService.ButtonColor.value, color: this.sharedService.TextButtonColor.value}"
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<password-expiry
  [manageSelf]="true"
  [triggerGetPeople$]="triggerGetPeople$"
  (checkForSaml)="handleOauth2Redirect()"
  [passwordExpirySettings]="passwordExpirySettings"
>
</password-expiry>

<ng-template #validatedUsername let-username let-avatar="avatar" let-removeFn="removeFn">
  <div class="row" >
    <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
              <span class="input-group-addon">
                <a>
                  <img
                    style="
                      float: left;
                      height: 35px;
                      width: 35px;
                      text-align: center;
                      vertical-align: middle;
                      margin: 10px 0 0 0;
                      border-radius: 50%;
                      overflow: hidden;
                    "
                    [src]="avatar"
                  />
                </a>
              </span>
      <div class="form-group label-floating is-empty">
                <span
                  style="
                    color: #3c4043;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.25px;
                    font-family: Arial, Helvetica, sans-serif;
                  "
                >
                  <b>{{ username }}</b>
                </span>
        <a
          style="cursor: pointer; color: #3c4043"
          class="pull-right"
          (click)="removeFn()"
          title="Remove account"
        >
          <i class="material-icons">clear</i>
        </a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #inputUserName let-passedModel let-form = "form" >
  <div class="row" >
    <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11">
        <span class="input-group-addon">
          <i class="material-icons">account_box</i>
        </span>
      <div
        class="form-group label-floating is-empty"
        [ngClass]="{'has-error': f?.submitted && !username.valid, 'is-empty': username == ''}"
      >
        <label class="control-label">Username</label>
        <input
          type="text"
          class="form-control"
          name="username"
          [(ngModel)]="passedModel.username"
          #username="ngModel"
          required
        />
      </div>
    </div>
  </div>
</ng-template>
